import { z } from "zod";

// 客服实际使用的模型摘要；不返回端点、密钥或加密凭据。无模型时为 null。
export const customerServiceProviderSchema = z.object({
  name: z.string(),
  model: z.string(),
  validation_status: z.enum(["ready", "blocked"]),
  validation_message: z.string()
}).nullable();

// 活动营销客服：客户、后台及后续小程序 / APP 共用的只读快照。
export const customerServiceConversationParamsSchema = z.object({ id: z.string().trim().min(1).max(128) });
export const customerServiceMessageSchema = z.object({
  id: z.string(),
  role: z.enum(["user", "assistant", "system"]),
  senderType: z.enum(["customer", "ai", "staff"]),
  content: z.string(),
  createdAt: z.string(),
  citations: z.array(z.object({ title: z.string() }))
});
export const customerServiceSnapshotSchema = z.object({
  conversation: z.object({
    id: z.string(),
    status: z.enum(["ai", "handoff", "human"]),
    channel: z.string(),
    updatedAt: z.string(),
    canReply: z.boolean()
  }),
  messages: z.array(customerServiceMessageSchema)
});

export const customerServiceTestSessionSchema = z.object({
  token: z.string().min(1),
  conversationId: z.string().min(1),
  expiresAt: z.string(),
  tenantName: z.string(),
  storeName: z.string().nullable()
});
export const customerServiceTestMessageInputSchema = z.object({
  message: z.string().trim().min(1).max(10000),
  idempotencyKey: z.string().trim().min(1).max(128)
}).strict();

/** @typedef {import("zod").infer<typeof customerServiceSnapshotSchema>} CustomerServiceSnapshot */
/** @typedef {import("zod").infer<typeof customerServiceMessageSchema>} CustomerServiceMessage */
/** @typedef {import("zod").infer<typeof customerServiceTestSessionSchema>} CustomerServiceTestSession */
/** @typedef {import("zod").infer<typeof customerServiceProviderSchema>} CustomerServiceProvider */
